import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { addJar } from './env'
import * as serviceWorker from './serviceWorker';


const App = lazy(() => import('./App'));

(async () => {

  await addJar({
    REACT_APP_API_URI: 'https://prod-api.smileweb.net',
    REACT_APP_BASENAME: '/',
  });

  await addJar(process.env);

  ReactDOM.render(<Suspense fallback={null}><App /></Suspense>, document.getElementById('root'));
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
